import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import ISkillLaunch from '../../../libs/utils/interfaces/skill-launch-interface';
import {
    saveSkillView,
    getCourseDetails,
    getCourseIdsByCourseIdentifiers,
} from './skill-launch-thunk';

const initialState = {
    asyncStatus: AsyncStatus.INITIAL,
    statusCode: 0,
    courseAsyncStatus: AsyncStatus.INITIAL,
    courseDetails: {},
    courseIdByIdentifier: 0,
    courseIdByIdentifierAsyncStatus: AsyncStatus.INITIAL,
} as ISkillLaunch;

const skillLaunchSlice = createSlice({
    name: 'skillLaunch',
    initialState,
    reducers: {},
    extraReducers(builder: any) {
        builder
            .addCase(saveSkillView.pending, (state: ISkillLaunch) => {
                state.asyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                saveSkillView.fulfilled,
                (state: ISkillLaunch, { payload }: any) => {
                    state.asyncStatus = AsyncStatus.SUCCESS;
                    state.statusCode = payload?.statusCode;
                }
            )
            .addCase(
                saveSkillView.rejected,
                (state: ISkillLaunch, { payload }: any) => {
                    state.asyncStatus = AsyncStatus.FAILURE;
                    state.statusCode = payload?.statusCode;
                }
            )
            .addCase(getCourseDetails.pending, (state: ISkillLaunch) => {
                state.courseAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                getCourseDetails.fulfilled,
                (state: ISkillLaunch, { payload }: any) => {
                    state.courseAsyncStatus = AsyncStatus.SUCCESS;
                    state.courseDetails = payload;
                }
            )
            .addCase(getCourseDetails.rejected, (state: ISkillLaunch) => {
                state.courseAsyncStatus = AsyncStatus.FAILURE;
            })
            .addCase(
                getCourseIdsByCourseIdentifiers.pending,
                (state: ISkillLaunch) => {
                    state.courseIdByIdentifierAsyncStatus = AsyncStatus.LOADING;
                }
            )
            .addCase(
                getCourseIdsByCourseIdentifiers.fulfilled,
                (state: ISkillLaunch, { payload }: any) => {
                    state.courseIdByIdentifierAsyncStatus = AsyncStatus.SUCCESS;
                    state.courseIdByIdentifier = payload[0]?.id;
                }
            )
            .addCase(
                getCourseIdsByCourseIdentifiers.rejected,
                (state: ISkillLaunch) => {
                    state.courseIdByIdentifierAsyncStatus = AsyncStatus.FAILURE;
                }
            );
    },
});

export default skillLaunchSlice.reducer;
